<div class="h-screen overflow-hidden">
  @if (showNotification()) {
    <app-notification message="OTP sent successfully" type="success" i18n-message="@@otpSmsNotificationSuccess" />
  }
  <div class="bgWhiteColor relative flex h-full items-center justify-center">
    <!-- Ellipse Decoration -->
    <div class="bg-ellipse"></div>

    <!-- Card -->
    <div class="bgBgColor relative z-10 flex min-h-[600px] w-[1024px] flex-col overflow-hidden rounded-[20px] p-10">
      <!-- Logo Top Left -->
      <div class="absolute top-6 left-6">
        <img src="assets/zlogo.svg" alt="ZPharma Logo" class="w-24" />
      </div>

      <!-- OTP Section -->
      <div class="mt-10 flex flex-col items-center text-center">
        <h2 class="mb-2 text-[36px] font-bold" i18n="@@otpSmsSentTitle">OTP Sent</h2>
        <img src="sms.png" alt="OTP Icon" class="mb-4 h-[140px] w-[160px]" />
        <p class="text-[24px] text-gray-600" i18n="@@otpSmsDescription">
          OTP SMS has been sent to your registered mobile number
        </p>
        <h2 class="textPrimaryColor mt-6 text-[32px] font-bold">
          @if (fromPage() == "register") {
            <span i18n="@@otpSmsCheckInboxActivate">Please check your SMS inbox to activate your account</span>
          } @else {
            <span i18n="@@otpSmsCheckInboxReset">Please check your SMS inbox to reset your password</span>
          }
        </h2>
      </div>

      <!-- OTP Input Boxes -->
      <form [formGroup]="otpForm" class="mt-2 flex flex-col items-center">
        <div class="mt-2 flex justify-center gap-4" dir="ltr">
          @for (digit of digits.controls; track $index) {
            <input
              id="otp-{{ $index }}"
              type="text"
              maxlength="1"
              [formControl]="digit"
              (input)="onInput($event, $index)"
              class="h-[74px] w-[74px] rounded-lg border border-gray-300 text-center text-[32px] font-bold focus:border-blue-500 focus:outline-none" />
          } @empty {
            <p i18n="@@otpSmsNoFields">No OTP fields available.</p>
          }
        </div>
        <div class="mt-6 text-center">
          <p class="mb-2 text-[14px] text-gray-600" i18n="@@otpSmsDidntReceive">Didn't receive the OTP?</p>
          <button
            (click)="resendOtp()"
            [disabled]="resendLoading() || resendCooldown() > 0"
            class="btn-primary w-fit rounded-lg px-6">
            @if (resendCooldown() > 0) {
              <span i18n="@@otpSmsResendCooldown">Resend OTP in {{ resendCooldown() }}s</span>
            } @else if (resendLoading()) {
              <span i18n="@@otpSmsResending">Resending...</span>
            } @else {
              <span i18n="@@otpSmsResendButton">Resend OTP</span>
            }
          </button>
        </div>

        @if (errorMessage() || showResend()) {
          <div
            class="errortextcolor mt-6 flex items-center gap-3 self-center rounded-[12px] border border-red-400 bg-red-100 px-4 py-2"
            style="width: calc((74px * 6) + (20px * 5))">
            <img src="errorVector.png" alt="Error" class="h-[20px] w-[21px]" />
            <div>
              @if (showResend()) {
                <strong class="text-[16px]" i18n="@@otpSmsExpiredTitle">OTP Expired</strong>
                <p class="text-[12px]" i18n="@@otpSmsExpiredDescription">
                  The OTP has expired. Please request a new one.
                </p>
              } @else {
                <strong class="text-[16px]" i18n="@@otpSmsErrorTitle">Something went wrong</strong>
                <p class="text-[12px]">{{ errorMessage() }}</p>
              }
            </div>
          </div>
        }
      </form>
    </div>
  </div>
</div>
